export const SUPERADMINMANAGEPRICING = 'SUPERADMINMANAGEPRICING'